import { render, staticRenderFns } from "./dailog-alarm-details.vue?vue&type=template&id=33e235ea&scoped=true"
import script from "./dailog-alarm-details.vue?vue&type=script&lang=js"
export * from "./dailog-alarm-details.vue?vue&type=script&lang=js"
import style0 from "./dailog-alarm-details.vue?vue&type=style&index=0&id=33e235ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e235ea",
  null
  
)

export default component.exports